module.exports = __webpack_public_path__ + "static/img/default.c24a1cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/default.png
// module id = OpSh
// module chunks = 6